import { render, staticRenderFns } from "./SampleValueTable.vue?vue&type=template&id=413b8a3f&scoped=true&"
import script from "./SampleValueTable.vue?vue&type=script&lang=js&"
export * from "./SampleValueTable.vue?vue&type=script&lang=js&"
import style0 from "./SampleValueTable.vue?vue&type=style&index=0&id=413b8a3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413b8a3f",
  null
  
)

export default component.exports